var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40.6 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 52v-14.2h2.6v-19.1h-2.6v-13.61l5.1-5.09h35.5v15.13l-5.16 5.17h-.64v11.3h5.8v15.23l-5.16 5.17z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m33.7 31.4v-12.2h1.27l4.53-4.54v-13.56h-33.93l-4.47 4.46v12.04h2.6v21.3h-2.6v12h33.87l4.53-4.54v-13.66h-10.3v-1.3z",
    className: "cjd-stroke",
    fill: "#8089a2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.09 35.48h7.53v-1.71h9.71v11.41h-31.65v-9.7h2.58v-23.6h-2.58v-9.71h31.65v11.36h-9.71v-1.65h-7.53v6.92h1.75v-1.65h9.66v13.06h-9.66v-1.7h-1.75z",
    className: "cjd-fill",
    fill: "#f9fbfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE);
export default __webpack_public_path__ + "static/media/e.62d32a9ee61a1a67aea4a127d0111a41.svg";
export { ForwardRef as ReactComponent };